class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.categorySelect = this.closest('form')?.querySelector('select[name="state"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    if (this.categorySelect) {
      this.categorySelect.addEventListener('change', this.onCategoryChange.bind(this));
    }
  }

  getSelectedCategory() {
    const selectedOption = this.categorySelect?.selectedOptions?.[0];
    if (!selectedOption) return '';

    const categoryLabel = selectedOption.textContent.trim();
    if (!categoryLabel || categoryLabel.toLowerCase() === 'all') return '';

    return categoryLabel;
  }

  getQuery() {
    return this.input?.value.trim() || '';
  }

  getSearchQuery() {
    const query = this.getQuery();
    const category = this.getSelectedCategory();

    if (!query.length) return '';
    if (!category.length) return query;

    return `${category} ${query}`.trim();
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onCategoryChange() {
    if (this.getQuery().length) {
      this.onChange();
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormSubmit() {
    const query = this.getSearchQuery();

    if (query.length) {
      this.input.value = query;
    }
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
